import { useNavigate, useParams } from "react-router-dom";
import MeaPage from "../../../components/MeaPage";
import ClassroomDetailComponent from "./components/ClassroomDetailComponent";
import classroomsAPI from "../../../services/classrooms";
import MeaPageTitle from "../../../components/MeaPageTitle";
import { useRef, useState } from "react";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import CreateClassroomModal from "./components/UpdateClassroomModal";
import ScheduleListComponent from "../schedule/components/ScheduleListComponent";
import { TabMenu } from "primereact/tabmenu";
import MeaLoadingContent from "../../../components/MeaLoadingContent";
import { PERMISSION_TRAINING_CLASSROOMS } from "../../../permissions";
import { useAuthContext } from "../../../hooks/useAuthContext";

const ClassroomDetailPage = () => {
  const { hasPermission } = useAuthContext();
  //
  const params = useParams();
  const schoolId = params.schoolId;
  const trainingId = params.trainingId;
  const accessToken = "";
  //
  const updateModalRef = useRef();
  const toast = useRef();
  const navigate = useNavigate();
  const classroomId = params.classroomId;
  //
  const classroomQuery = classroomsAPI.GetOne(
    schoolId,
    trainingId,
    accessToken,
    classroomId
  );
  const classroomObj = classroomQuery?.data?.data;
  // states
  const [activeItem, setActiveItem] = useState(0);
  const listRef = useRef();
  // params
  const items = [{ label: "Programme de la semaine", icon: "pi pi-clock" }];
  //
  return (
    <>
      <MeaPage
        title={<MeaPageTitle prefix={"Salle:"} title={classroomObj?.name} />}
        showBackButton={true}
        actions={[
          {
            label: "Modifier",
            icon: "pi pi-file-edit",
            command: () => {
              if (updateModalRef.current) {
                updateModalRef.current.show(() => {
                  classroomQuery.refetch();
                });
              }
            },
            disable: !hasPermission(PERMISSION_TRAINING_CLASSROOMS.UPDATE)
          },
          {
            separator: true,
            disable: !hasPermission(PERMISSION_TRAINING_CLASSROOMS.UPDATE)
          },
          {
            label: "Supprimer",
            icon: "pi pi-trash",
            disable: !hasPermission(PERMISSION_TRAINING_CLASSROOMS.DELETE),
            command: () => {
              confirmDialog({
                message: "Voulez-vous vraiment supprimer cette salle?",
                header: "Confirmation",
                icon: "pi pi-info-circle",
                defaultFocus: "reject",
                acceptClassName: "p-button-danger",
                accept: () => {
                  classroomsAPI
                    .DeleteOne(schoolId, trainingId, accessToken, classroomId)
                    .then((data) => {
                      toast.current.show({
                        severity: "success",
                        summary: "Succès",
                        detail: classroomObj?.name + " Supprimé!",
                        life: 3000,
                      });
                      navigate(
                        "/school/" + schoolId + "/admin/trainings/" + trainingId + "/classrooms"
                      );
                    })
                    .catch((error) => {
                      toast.current.show({
                        severity: "error",
                        summary: "Erreur",
                        detail: "Erreur de suppression!",
                      });
                    });
                },
              });
            },
          },
        ]}
      >
        <ClassroomDetailComponent classroom={classroomObj} />
        <CreateClassroomModal ref={updateModalRef} classroom={classroomObj} schoolId={schoolId} trainingId={trainingId} accessToken={accessToken} />
        <ConfirmDialog />
        <Toast ref={toast} />
        <div className="mt-5">
          <TabMenu
            model={items}
            activeIndex={activeItem}
            onTabChange={(e) => {
              setActiveItem(e.index);
            }}
          />
          {activeItem === 0 && (
            <MeaLoadingContent objectQuery={classroomQuery}>
              <ScheduleListComponent
                ref={listRef}
                schoolId={schoolId}
                trainingId={trainingId}
                filter={{ classroom_id: classroomId }}
                showAddButton={false}
                showFilterButton={true}
                selectedFields={{
                  classroom: false,
                }}
              />
            </MeaLoadingContent>
          )}
        </div>
      </MeaPage>
    </>
  );
};
export default ClassroomDetailPage;
